const templateUrl = require('./sku-swap.html');

module.exports = {
  bindings: {
    subscription: '<ogFor'
  },
  controller: require('./sku-swap.controller'),
  templateUrl: templateUrl
};
